<template lang="pug">
el-dropdown.map_dropdown(placement="bottom-start" trigger="click" ref="dropDownCtn")
  el-button.map_button(
    :icon="icon" :style="{color: areaV ? 'rgb(255, 57, 115)' : ''}"
  ) {{ areaV ? areaV + '公里' : '投放范围' }}
    <slot name="right-icon"></slot>
  el-dropdown-menu.map_select_dropdown(slot="dropdown")
    li.map_select_ul(:class="{'map_group_ul': group}")
      ul
        template(v-for="item in dataList")
          li.map_select_groupname(v-if="group && item.groupName" :key="item.groupName" v-text="item.groupName")
          li.map_select_list(
            v-else
            :key="item.value"
            v-text="item.label"
            @click="onSelect(item)"
          )
      ul.nav_ul
        li.nav_list(v-for="nav in groupNav" :key="nav.groupName") {{ nav.groupName}}
      div.input_box(v-show="custom")
        el-input-number.custom_input(
          size="mini"
          :class="{'focus': unitVisible}"
          :controls="false"
          :placeholder="cPlaceholder"
          :min="0.01"
          :max="500"
          :precision="2"
          :step="0.1"
          v-model="defineValue"
          @focus="inputFocus = true"
          @blur="handleBlur"
        )
        span.input_unit(v-show="unitVisible") {{customUnit}}
</template>

<script>
/**
 * 地图内 下拉列表组件
 */
export default {
  name: 'MapSelect',
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    /**
     * 支持自定义值
     */
    custom: {
      type: Boolean,
      default: true
    },
    customPlaceholder: {
      type: String,
      default: '请选择'
    },
    customUnit: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    /**
     * 支持分组
     */
    group: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      defineValue: undefined,
      inputFocus: false,
      groupNav: []
    }
  },
  computed: {
    unitVisible() {
      return this.inputFocus || this.defineValue >= 0
    },
    cPlaceholder() {
      if (this.unitVisible) {
        return ''
      } else {
        return this.customPlaceholder
      }
    },
    dataList() {
      if (this.group) {
        return this.groupData()
      } else {
        return this.data
      }
    },
    areaV() {
      return this.$store.state.bmap.mapSearchOptionsSenior.areaValue
    }
  },
  created() {
    this.name = this.placeholder
  },
  methods: {
    // 输入框失焦事件处理（无需额外监听键盘回车事件,因按下回车键时必然触发失焦）
    handleBlur() {
      this.inputFocus = false
      this.handleKeydownItem()
    },
    onSelect(data) {
      this.name = data.label
      this.$emit('input', data.value)
      this.$refs.dropDownCtn.hide()
    },
    handleKeydownItem() {
      let v = this.defineValue
      if (v > 0) {
        this.name = v + this.customUnit
        this.$emit('input', v)
      } else {
        this.defineValue = undefined
        this.messageTip('投放范围须大于0公里')
      }
      this.$refs.dropDownCtn.hide()
    },
    groupData() {
      let group = {}
      this.data.forEach((e) => {
        if (!group[e.group]) {
          group[e.group] = []
        }
        group[e.group].push(e)
      })
      let arr = []
      let nav = []
      for (let key in group) {
        arr.push({
          value: '',
          groupName: key
        })
        nav.push({
          value: '',
          groupName: key
        })
        arr = arr.concat(group[key])
      }
      this.groupNav = nav
      return arr
    }
  }
}
</script>

<style lang="sass" scoped>
.map_dropdown
    width: 84px
    ::v-deep > button
        width: 100%
.map_select_ul
    width: 84px
.map_group_ul
    width: 280px
    height: 280px
    padding: 0 35px 0 20px
    margin-right: 5px
    overflow-y: auto
    .map_select_list
        padding-left: 10px
        text-align: left
        &:hover
            background-color: #F5F5F5 !important
    .nav_ul
        position: absolute
        top: 20px
        right: 20px
        color: #282729
        font-size: 12px
        line-height: 17px
    .nav_list
        display: block
        width: 17px
        text-align: center
        cursor: pointer
        &:hover
            font-size: 16px
            margin: 4px 0
            text-shadow: 1px 2px 4px #aaa
.map_select_groupname
    color: #282729
    line-height: 30px
.map_select_list
    padding: 7px 0px 6px
    height: 30px
    color: #282729
    font-size: 12px
    text-align: center
    line-height: 17px
    cursor: pointer
    &:nth-child(even):hover
        background-color: rgba(#FF3973, 0.11)
    &:nth-child(odd):hover
        background-color: rgba(#FF3973, 0.21)
.custom_input
    width: 80px
    height: 30px
    margin: 10px 2px 0
    line-height: 30px
    border-color: #E9E9E9
    ::v-deep .el-input__inner
        padding: 0 10px
        background-color: #F5F5F5
    &.focus
        ::v-deep .el-input__inner
            padding-right: 34px
.input_box
    position: relative
    .input_unit
        position: absolute
        right: 10px
        top: 10px
        color: #282729
        font-size: 12px
        line-height: 30px
</style>
